import Tween from "tween.ts";
import Animation from "../Animation";
import Line from "../../entities/Line/Line";
import { Coord } from "../../types/Interface";


export default class DrawLineAnim extends Animation {
  private Anim = Animation.getInstance();
  private isStopped = false;
  constructor(Line: Line, readonly sCoord: Coord, readonly tCoord: Coord, delay: number = 0, onComp: () => void, resolve: () => void) {
    super();

    if(this.Anim.getIsCancelled()) {
      resolve();
      return 
    };
    


    new Tween.Tween({ ...sCoord })
      .to({ x: tCoord.x, y: tCoord.y }, 1000)
      .delay(delay)
      .easing(Tween.Easing.Linear.None)
      .onUpdate((coord: Coord, u) => {
        const isCancelled =  this.Anim.getIsCancelled();
        if(isCancelled) {
          this.isStopped = true;
          onComp();
        }
        if(!this.isStopped) {
          Line.draw(sCoord, coord);
        }
      })
      .onComplete(() => onComp())
      .start() ;
  }
}